module.exports = "/images/doodle-website-16c543067a40a3211d208661c65a3ff0.png";